import React, { useEffect, useState } from 'react';

interface CountdownSpinnerProps {
  countdown: number | null;
}

export const CountdownSpinner: React.FC<CountdownSpinnerProps> = ({ countdown }) => {
  const [pulse, setPulse] = useState(false);

  // Pulse animation effect when countdown changes
  useEffect(() => {
    if (countdown !== null) {
      setPulse(true);
      const timeout = setTimeout(() => setPulse(false), 300);
      return () => clearTimeout(timeout);
    }
  }, [countdown]);

  if (countdown === null) return null;

  // Calculate percentage for circle stroke-dashoffset animation
  const percentage = (countdown / 10) * 100; // Assuming 10 seconds total
  const circumference = 2 * Math.PI * 10; // 2πr where r=10

  return (
    <div className="relative inline-flex items-center justify-center ml-2">
      <svg className="w-8 h-8" viewBox="0 0 24 24">
        {/* Background circle */}
        <circle
          className="text-gray-400 opacity-30"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="2"
          fill="none"
        />
        {/* Animated progress circle */}
        <circle
          className="transition-all duration-1000 ease-linear text-primary"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="2"
          fill="none"
          strokeDasharray={circumference}
          strokeDashoffset={circumference - (percentage / 100) * circumference}
          strokeLinecap="round"
          transform="rotate(-90 12 12)"
        />
      </svg>
      <span
        className={`absolute text-xs font-bold text-white transition-transform duration-300 ${
          pulse ? 'scale-125' : 'scale-100'
        }`}
      >
        {countdown}
      </span>
    </div>
  );
};
